export enum ColumnStyle {
  None = 'none',
  Post = 'post',
  PostWithDecoratedEndsOnBase = 'post-with-decorated-ends-on-base',
  PostWithAngledEnds = 'post-with-angled-ends',
  PostWithEnds = 'post-with-ends',
  RoundPost = 'round-post',
}
